import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  skeleton: {
    margin: "5px",
    backgroundColor: "#ccc",
  }
}));

export default useStyles;
